import ResetPasswordUser from './ResetPasswordUserPage';

export default ResetPasswordUser;
